//FOR LOGIN
export const USER_lOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_lOGIN_SUCCESS="USER_LOGIN_SUCCESS";
export const USER_lOGIN_ERROR = "USER_LOGIN_ERROR";
// FOR REGITER
export const USER_REGISTER_REQUEST="USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS="USER_REGISTER_SUCCESS";
export const USER_REGISTER_ERROR = "USER_REGISTER_ERROR";

//FOR LOGOUT
export const USER_lOGOUT_SUCCESS="USER_LOGOUT_SUCCESS";